(function () {
  'use strict';

  var trigger = document.getElementById('wtpb-reviews-launcher');
  var drawer = document.getElementById('wtpb-reviews-drawer');
  if (!trigger || !drawer) return;

  var dialog = drawer.querySelector('[role="dialog"]');
  var closeButton = drawer.querySelector('.wtpb-reviews-drawer__close');
  var header = document.querySelector('.header-group');
  var breadcrumb = document.querySelector('.breadcrumbs-list__item');
  var revealTimer;
  var lastPointerType = '';
  var touchRevealed = false;
  var pointerInside = false;
  var framePending = false;

  function tuckLauncher() {
    window.clearTimeout(revealTimer);
    trigger.classList.remove('is-revealed');
    touchRevealed = false;
  }

  function revealLauncher(timed) {
    window.clearTimeout(revealTimer);
    trigger.classList.add('is-revealed');
    if (timed) {
      revealTimer = window.setTimeout(function () {
        if (drawer.hidden && !pointerInside) tuckLauncher();
      }, 5000);
    }
  }

  function positionLauncher() {
    framePending = false;
    var headerBottom = 0;
    if (header) {
      var headerParts = [header].concat(Array.prototype.slice.call(header.querySelectorAll('header, [role="banner"]')));
      headerParts.forEach(function (part) {
        var rect = part.getBoundingClientRect();
        if (rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0) {
          headerBottom = Math.max(headerBottom, rect.bottom);
        }
      });
    }
    var top = Math.max(88, Math.ceil(headerBottom + 10));
    if (breadcrumb) {
      var breadcrumbRect = breadcrumb.getBoundingClientRect();
      if (breadcrumbRect.height > 0 && breadcrumbRect.bottom > 0 && breadcrumbRect.top < top + 100) {
        top = Math.max(top, Math.ceil(breadcrumbRect.bottom + 10));
      }
    }
    top = Math.min(top, Math.max(0, window.innerHeight - (trigger.offsetHeight || 72) - 16));
    var value = top + 'px';
    if (trigger.style.getPropertyValue('--wtpb-reviews-top') !== value) {
      trigger.style.setProperty('--wtpb-reviews-top', value);
    }
  }

  function schedulePosition() {
    if (framePending) return;
    framePending = true;
    window.requestAnimationFrame(positionLauncher);
  }

  trigger.addEventListener('pointerenter', function (event) {
    if (window.matchMedia('(hover: hover)').matches && (event.pointerType === 'mouse' || event.pointerType === 'pen')) {
      pointerInside = true;
      revealLauncher(false);
    }
  });

  trigger.addEventListener('pointerleave', function (event) {
    if (window.matchMedia('(hover: hover)').matches && (event.pointerType === 'mouse' || event.pointerType === 'pen')) {
      pointerInside = false;
      if (drawer.hidden) tuckLauncher();
    }
  });

  trigger.addEventListener('pointerdown', function (event) {
    lastPointerType = event.pointerType;
  });

  // Record touch independently of click.detail, including legacy mobile clicks.
  trigger.addEventListener('touchstart', function () {
    lastPointerType = 'touch';
  }, { passive: true });
  trigger.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') lastPointerType = 'keyboard';
  });
  trigger.addEventListener('pointercancel', function () {
    lastPointerType = '';
    pointerInside = false;
    if (drawer.hidden) tuckLauncher();
  });

  trigger.addEventListener('blur', function () {
    lastPointerType = '';
    if (!pointerInside && drawer.hidden) tuckLauncher();
  });

  function handleOutsidePress(event) {
    if (!trigger.contains(event.target) && drawer.hidden) {
      pointerInside = false;
      tuckLauncher();
    }
  }
  document.addEventListener('pointerdown', handleOutsidePress);
  document.addEventListener('touchstart', handleOutsidePress, { passive: true });

  window.addEventListener('scroll', function () {
    if (drawer.hidden && !pointerInside) tuckLauncher();
    schedulePosition();
  }, { passive: true });
  window.addEventListener('resize', schedulePosition);
  if (header && 'ResizeObserver' in window) {
    new window.ResizeObserver(schedulePosition).observe(header);
  }
  positionLauncher();

  function focusableElements() {
    if (!dialog) return [];
    return Array.prototype.filter.call(
      dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (element) {
        return element.offsetWidth > 0 && element.offsetHeight > 0;
      }
    );
  }

  function track(eventName) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName });
    } catch (error) {}
  }

  function openDrawer() {
    tuckLauncher();
    drawer.hidden = false;
    document.body.classList.add('wtpb-reviews-open');
    trigger.setAttribute('aria-expanded', 'true');
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (closeButton) closeButton.focus();
    });
    track('wtpb_reviews_open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('wtpb-reviews-open');
    trigger.setAttribute('aria-expanded', 'false');
    drawer.hidden = true;
    pointerInside = false;
    tuckLauncher();
    trigger.focus({ preventScroll: true });
  }

  trigger.addEventListener('click', function (event) {
    var touchClick = lastPointerType !== 'keyboard' && (
      lastPointerType === 'touch' || event.pointerType === 'touch' ||
      (event.sourceCapabilities && event.sourceCapabilities.firesTouchEvents) ||
      window.matchMedia('(hover: none)').matches
    );
    lastPointerType = '';
    // A hover (real or synthesized) must never count as the first mobile tap.
    if (touchClick && !touchRevealed) {
      pointerInside = false;
      touchRevealed = true;
      revealLauncher(true);
      return;
    }
    openDrawer();
  });
  drawer.querySelectorAll('[data-wtpb-reviews-close]').forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (event) {
    if (drawer.hidden) {
      if (event.key === 'Escape') {
        pointerInside = false;
        tuckLauncher();
      }
      return;
    }
    if (event.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = focusableElements();
    if (!focusable.length) {
      event.preventDefault();
      if (dialog) dialog.focus();
      return;
    }

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  if (dialog) {
    dialog.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }
}());
